import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterExpensesView.
 * @extends JetView
 */
export default class FilterExpensesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing text input for 'Consecutive'
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Consecutive',
                    type: 'text',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Consecutivo'),
                    labelPosition: 'top',
                    placeholder: _('Consecutivo'),
                },
            ],
        };

        // Center left section containing date picker and date input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'datepicker',
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: moment().format('YYYY-MM-DD'), // Default date value
                    format: '%d %M %Y',
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum selectable date
                        },
                    },
                },
            ],
        };

        // Center right section containing radio buttons for credit card selection
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'radio',
                    name: 'CreditCards',
                    label: _('Tarjeta de crédito'),
                    labelPosition: 'top',
                    value: 0,
                    options: [
                        { id: 0, value: _('Sí') },
                        { id: 1, value: _('No') },
                    ],
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Additional sections for filtering options
        const left2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'TypeEgress',
                    id: 'TypeEgressFilter',
                    label: _('Tipo de Egreso'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        const center_left2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'Concepts',
                    id: 'ConceptsFilter',
                    label: _('Concepto'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        const center_right2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'DocumentID',
                    type: 'number',
                    label: _('Documento ID'),
                    labelPosition: 'top',
                    placeholder: _('Documento ID'),
                },
            ],
        };

        const right2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: _('Todos') },
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
            ],
        };

        // Upper section layout
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Second upper section layout
        const upper_section2 = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left2, center_left2, center_right2, right2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Removes Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Removes Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('expense:filter', [filterdata]); // Calls filter event
                        $$('b5').collapse(); // Collapses the accordion
                    },
                },
            ],
        };

        // Main accordion section containing filters and buttons
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Returns the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section2],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hides Date input if typeDate is not 2
                $$('Datepicker').show(); // Shows Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Shows Date input if condition is true
                    $$('Datepicker').hide(); // Hides Datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Gets current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Sets date modal based on language
        });

        // AJAX request to fetch types for Egress filter
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', '{"Type":2}', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Displays error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parses response
                    $$('TypeEgressFilter').define('options', resp.Data); // Sets options for TypeEgress filter
                    $$('TypeEgressFilter').refresh(); // Refreshes the filter
                },
            });

        // AJAX request to fetch concepts for Concepts filter
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Displays error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parses response
                    $$('ConceptsFilter').define('options', resp.Data); // Sets options for Concepts filter
                    $$('ConceptsFilter').refresh(); // Refreshes the filter
                },
            });
    }
}

// FILE DOCUMENTED
